// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-date-header[data-v-2d2a66d5] {\n  color: var(--dark-green-60, #66827f);\n  font-size: 0.88rem !important;\n  font-weight: 400;\n}\n.top-date-header span[data-v-2d2a66d5] {\n  color: var(--dark-green-100, #002e2a);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
